exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress-bar{background:#f44336;-webkit-box-shadow:0 0 5px #f44336;box-shadow:0 0 5px #f44336;position:fixed;left:0;top:0;height:2px;width:0;z-index:9999;-webkit-transition:width .5s;transition:width .5s}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-17309712","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/core/structure/progressBar/ProgressBar.vue
// module id = Oewi
// module chunks = 66